export default __webpack_public_path__ + "static/media/code2.0096c94a.jpg";